import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthCallbackComponent } from './auth-callback.component';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
    declarations: [AuthCallbackComponent],
    imports: [CommonModule, FlexLayoutModule],
    exports: [AuthCallbackComponent],
    providers: [],
})
export class AuthCallbackModule {}
